import React from 'react';
import {useTranslation} from "react-i18next";
import {ReactComponent as GoPOSLogoDark} from "../../../../../images/logo/gopos_logo_dark.svg";
import {ReactComponent as GoPOSLogo} from "../../../../../images/logo/gopos.svg";
import AppConfig from "../../../../services/AppConfig";

const FooterBottom = ({}) => {
    const {t} = useTranslation();

    return (
        <div className={"footer-bottom"}>
            <a className={"footer-powered-by"}
               href="https://gopos.pl/goorder" target="_blank"
               title={t("modules.footer.field.online_orders.title")}>
                    <span>
                        {t("modules.footer.field.use_ordering_system.title")}
                    </span>
                {AppConfig.isDarkMode() ? <GoPOSLogo/> : <GoPOSLogoDark/>}
            </a>
        </div>
    )
}

export default FooterBottom;